import { Phone, Siren } from "lucide-react";
import { CONTACT } from "@/constants/contact";

export const UrgenceBanner = () => (
  <div
    data-testid="urgence-banner"
    className="relative z-50 flex items-center justify-center gap-2 bg-primary px-4 py-2 text-center text-sm font-semibold text-primary-foreground"
  >
    <Siren className="h-4 w-4 shrink-0 animate-pulse" />
    <span>En panne ? Appelez-nous :</span>
    <a
      href={CONTACT.phoneHref}
      data-testid="urgence-call-link"
      className="underline underline-offset-4 hover:no-underline"
    >
      {CONTACT.phoneDisplay}
    </a>
    <Phone className="hidden h-4 w-4 shrink-0 sm:inline" />
  </div>
);
